import Loading from 'components/ui/Loading'
import styled from 'styled-components'

const Page = styled.div`
  background-color: #fefefe;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-direction: column;
`

export default function PageLoading() {
  return (
    <Page>
      <Loading />
    </Page>
  )
}
